import { FolderItem, TokenAccess, VaultResponse } from "./entities";
import { httpGet, httpPost } from "@eres/rest";
import cfg from "./config";

function randromDigit() {
	return "0123456789"[ Math.floor( Math.random() * 10 ) ];
}

function randromChar() {
	return "ABCDEFGHIJKLMNOPQRSTUVWXYZ"[ Math.floor( Math.random() * 26 ) ];
}

function randomId() {
	return [ ...Array( 7 ) ].map( ( _, i ) => randromChar() ).join( "" );
}

export function searchUserVault( refId: string ): Promise<VaultResponse<FolderItem>> {
	return httpGet( `${ cfg.vaultApi().endPoint() }share/files/list?refNumber=${ encodeURIComponent( refId ) }` );
}

export function requestAccess( files: string[] ): Promise<VaultResponse<{ refNumber: string }>> {
	return httpPost( `${ cfg.vaultApi().endPoint() }share/files/otp`, files );
}

export function verifyAccessToken( reqId: string, accessCode: string ): Promise<VaultResponse<TokenAccess[]>> {
	return httpPost( `${ cfg.vaultApi().endPoint() }share/files/links`, {
		refNumber: reqId,
		otp: accessCode
	} );
}

export function resendAccessToken( reqId: string ): Promise<VaultResponse<TokenAccess[]>> {
	return httpPost( `${ cfg.vaultApi().endPoint() }share/files/links/resend`, {
		refNumber: reqId,
	} );
}


export function isVaultEndpoint( url: string ): boolean {
	return url.indexOf( cfg.vaultApi().endPoint() ) === 0;
}
